import { TranslocoService } from '@ngneat/transloco';
import { forkJoin } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { AcModel } from 'projects/core/src/lib/models/ac.model';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { PartnerModel } from 'projects/core/src/lib/models/partner.model';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-ac-detail',
  templateUrl: './ac-detail.component.html',
  styleUrls: ['./ac-detail.component.scss']
})
export class AcDetailComponent extends BaseDetail implements OnInit {

  public ac: AcModel = null;
  public partners: Array<PartnerModel> = [];
  public mode = 'planned';
  public backRoute = ['/acs'];

  protected identifier = 'ac';

  constructor(
    protected ui: UiService,
    protected router: Router,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private api: ApiService,
    private route: ActivatedRoute,
    public auth: AuthStateService,
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.mode) {
        this.mode = params.mode;
        this.backRoute = ['/acs', this.mode];
      }
      if (params.id === 'new') {
        this.setInitialized(DetailModes.new);
      } else if (params.id) {
        this.setLoading();
        forkJoin([
          this.api.getModel('acs', params.id),
          this.api.getModels('partners')
        ]).subscribe({
          next: (result: any) => {
            this.ac = new AcModel().deserialize(result[0].data);
            this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab-' + this.ac.id), 10);
            if (result[1] !== null && result[1].data.length > 0) {
              result[1].data.forEach((partner: any) => {
                this.partners.push(new PartnerModel().deserialize(partner));
              });
            }
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        }
        );
      } else {
        this.onClose();
      }
    });
  }

  onTabChange(event: any): void {
    if (this.ac !== null) {
      localStorage.setItem(this.identifier + '-tab-' + this.ac.id, event.index);
    }
    this.ui.setFocus();
  }

}
